import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { InquiryService } from 'src/app/services/inquiry.service';
import { CategoryItem, TicketStatus, ResolutionType ,DataItem } from 'src/app/interface/ticket';
@Component({
  selector: 'app-mobile-inquiry',
  templateUrl: './mobile-inquiry.component.html',
  styleUrls: ['./mobile-inquiry.component.css']
})
export class MobileInquiryComponent implements OnInit,OnDestroy {
  pageIndex: number = 1; //当前页面
  pageSize: number = 20; //当前页面数量
  loading: boolean = false; //是否加载中
  total: number = 0; //列表总数据
  keywords: string = "";  //关键词搜索
  ticketStatusID: number = 0;//搜索ticketStatusID
  categoryID: number = 0; //搜索categoryID
  resolutionTypeID: number = 0;//搜索resolutionTypeID
  isSupport = false; //是否IT support
  isDescrSubmittedDate:string = "";
  ticketStatusList:TicketStatus[] = [];
  resolutionTypeList:ResolutionType[] = [];
  problemCategoryList:CategoryItem[]  = [] ;
  lang = localStorage.getItem('lang')  ||  'en'
  listOfData: DataItem[] = [];//列表数据
  timer:any = null;
  filterVisible:boolean = false;
  @ViewChild('filter') param:any;
  searchFilterParam:any = {};
  constructor(private router: Router,private inquiryService: InquiryService,private message: NzMessageService,
    private activatedRoute: ActivatedRoute) {
     //通过email Link打开详情页面
     this.activatedRoute.queryParams.subscribe(
      (queryParams: any) => {
        if (queryParams.ticketId) {
          this.router.navigate(['/mobile-ticket'],{queryParams:{guid:queryParams.ticketId}});
        }
      }
    )
   }
  ngOnInit(): void {
    this.isSupport = localStorage.getItem("isSupport") == "true" ? true : false;
    this.searchInquiryList();
  }
  ngOnDestroy(): void {
    clearTimeout(this.timer);
  }

  addTicket():void{
      this.router.navigate(['/mobile-ticket']);
  }
  searchInquiryList(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }
    this.loading = true;
    let param = {
      "page": this.pageIndex - 1,
      "pageSize": this.pageSize,
      "keyword": this.keywords,
      "ticketStatusIDs": this.searchFilterParam.ticketStatusIDs || null,
      "categoryIDs":  this.searchFilterParam.categoryIDs|| null,
      "assignedToTeamIDs":  this.searchFilterParam.categoryIDs|| null,
      "submittedDateStart": this.searchFilterParam.submittedDateStart|| null,
      "submittedDateEnd": this.searchFilterParam.submittedDateEnd|| null,
      "acceptedDateStart": this.searchFilterParam.acceptedDateStart|| null,
      "acceptedDateEnd": this.searchFilterParam.acceptedDateEnd|| null,
      "closedDateStart": this.searchFilterParam.closedDateStart|| null,
      "closedDateEnd": this.searchFilterParam.closedDateEnd|| null,
      "isDescTicketNo": this.searchFilterParam.isDescTicketNo ,
      "isDescAcceptedBy": this.searchFilterParam.isDescAcceptedBy ,
      "isDescSubmittedBy": this.searchFilterParam.isDescSubmittedBy ,
      "isDescClosedBy": this.searchFilterParam.isDescClosedBy ,
      "isDescAcceptedDate": this.searchFilterParam.isDescAcceptedDate,
      "isDescSubmittedDate": this.searchFilterParam.isDescSubmittedDate,
      "isDescClosedDate": this.searchFilterParam.isDescClosedDate,
      "acceptedBy": this.searchFilterParam.acceptedBy || ''
    }
    if(param.isDescTicketNo == null && param.isDescAcceptedBy == null && param.isDescSubmittedBy == null && param.isDescClosedBy == null && param.isDescAcceptedDate == null && param.isDescSubmittedDate == null && param.isDescClosedDate == null  ){
      param.isDescTicketNo = true;
    }
    this.inquiryService.getInquiryList(param).subscribe(
      {
        next: (res) => {
          this.loading = false;
          this.listOfData = res.data;
          this.total = res.total;
        },
        error: (error) => {
          this.message.error(error.statusText);
          this.loading = false;
        }
      }
    )
  }

  showInfo(ticketInfo: any) {
    this.router.navigate(['/mobile-ticket'],{queryParams:{guid:ticketInfo.ticket.guid}});
  }

  showFilter(): void {
    this.filterVisible = true;
  }
  close(): void {
    this.filterVisible = false;
  }
  save():void{
    this.close();
    this.searchFilterParam = {
      "page": this.pageIndex - 1,
      "pageSize": this.pageSize,
      "keyword": this.keywords,
      "ticketStatusIDs": this.param?.ticketStatusList.filter((item: { checked: any; })=>{return item.checked }).map((item: { value: any; })=>{return item.value}).length> 0 ?this.param?.ticketStatusList.filter((item: { checked: any; })=>{return item.checked }).map((item: { value: any; })=>{return item.value}): null ,
      "categoryIDs":  this.param?.problemCategoryList.filter((item: { checked: any; })=>{return item.checked }).map((item: { value: any; })=>{return item.value}).length> 0 ?this.param?.problemCategoryList.filter((item: { checked: any; })=>{return item.checked }).map((item: { value: any; })=>{return item.value})  : null,
      "assignedToTeamIDs":  this.param?.supportTeamList.filter((item: { checked: any; })=>{return item.checked }).map((item: { value: any; })=>{return item.value}).length> 0 ?this.param?.supportTeamList.filter((item: { checked: any; })=>{return item.checked }).map((item: { value: any; })=>{return item.value})  : null,
      "submittedDateStart": this.param?.submittedDateStart || null,
      "submittedDateEnd": this.param?.submittedDateEnd || null,
      "acceptedDateStart": this.param?.acceptDateStart || null,
      "acceptedDateEnd": this.param?.acceptDateEnd|| null,
      "closedDateStart": this.param?.closedDateStart || null,
      "closedDateEnd": this.param?.closedDateEnd|| null,
      "isDescTicketNo": this.param?.isDescTicketNo == "" ? null :  this.param?.isDescTicketNo != "false",
      "isDescAcceptedBy": this.param?.isDescAcceptedBy  ==  "" ? null : this.param?.isDescAcceptedBy != "false",
      "isDescSubmittedBy": this.param?.isDescSubmittedBy  ==  "" ? null  : this.param?.isDescSubmittedBy != "false",
      "isDescClosedBy": this.param?.isDescClosedBy  ==  "" ? null : this.param?.isDescClosedBy != "false",
      "isDescAcceptedDate": this.param?.isDescAcceptedDate  ==  "" ? null : this.param?.isDescAcceptedDate != "false",
      "isDescSubmittedDate": this.param?.isDescSubmittedDate  ==  "" ? null : this.param?.isDescSubmittedDate != "false",
      "isDescClosedDate": this.param?.isDescClosedDate  ==  "" ? null : this.param?.isDescClosedDate != "false",
      "acceptedBy":this.param?.acceptedBy || ''
    }
    this.searchInquiryList();
  }

  getStatus(id: number) {
    let status:any = {
      1:'Submitted',
      2:this.isSupport ? 'In Progress (Accepted)' : 'In Progress',
      3:'Closed',
      4:this.isSupport ? 'In Progress (Reassigned)' : 'In Progress',
      5:'Canceled'
    }
    return status[id]
  }

  refresh(){
    this.searchFilterParam = {};
    this.searchInquiryList(true);
  }
}
